import { EducationalInfoService } from './educational-info.service';
import { Component, Inject, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-educational-info',
  templateUrl: './educational-info.component.html',
  styleUrls: ['./educational-info.component.css'],
})
export class EducationalInfoComponent implements OnInit {
  payload;
  educationTypes;
  showEnglishAndMaths = false;
  selectedType = '';
  aLevel = false;
  todayDate: Date;
  to: Date;
  from: Date;
  toDateGreaterThanFromDate: boolean;

  constructor(
    private educationalInfoService: EducationalInfoService,
    @Inject(DOCUMENT) private _document: Document
  ) {}

  ngOnInit(): void {
    this.getEducationTypes();
    this.showEnglishAndMaths;
    this.aLevel;
    this.todayDate = new Date();
  }

  checkTo(dateFrom) {
    this.from = new Date();
  }

  checkIfDateIsLessThanCurrentDate(dateGet) {
    this.to = new Date(dateGet);

    if (this.from > this.to) {
      this.toDateGreaterThanFromDate = true;
      console.log('====================== greater than current date :: ');
    } else {
      this.toDateGreaterThanFromDate = false;
      console.log('====================== less than current date :: ');
    }
  }

  getEducationTypes() {
    this.educationalInfoService.getEducationalTypes().subscribe((response) => {
      this.educationTypes = response;
    });
  }

  onChange(educationType) {
    this.selectedType = educationType;
    if (educationType.match("O'Level")) {
      this.showEnglishAndMaths = true;
      this.aLevel = false;
    } else if (educationType.match("A'Level")) {
      this.showEnglishAndMaths = false;
      this.aLevel = true;
    } else {
      this.showEnglishAndMaths = false;
      this.aLevel = false;
    }
  }

  onSubmit(data) {
    console.log('Form submit, benefits ===>>>  ', data);
    this.educationalInfoService
      .createEducationInfo(data)
      .subscribe((response) => {
        if (response['id'] !== null) {
          Swal.fire('Done!', 'Education info saved!', 'success').then(
            (result) => {
              if (result.value) {
                this.delay(300);
              }
            }
          );
        }
      });
  }

  async delay(ms: number) {
    await new Promise((resolve) => setTimeout(resolve, ms));
    await this._document.defaultView.location.reload();
  }
}
